import { usePayoutTypeSelectOptions } from "components/UI/Selects/PayoutTypeSelectSearchable/usePayoutTypeSelectOptions.ts";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

export const PayoutTypeSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = usePayoutTypeSelectOptions();

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.payout_type"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
